import { Button, Table, TableBody, TableCell, TableRow } from "@mui/material";
import axios from "axios";
import { ProjectConfig } from "Global";
import { useEffect, useState } from "react";
import LogsEditor from "./LogsEditor";

export default function Logs(props: any) {

    const { 
        store_id
    } = props;

    const [activityLogs, setActivityLogs] = useState([]);
    const [openEditor, setOpenEditor] = useState(false);

      useEffect(() => {
        getActivityLogs();
      }, [])
      
      /*=========================================================
      GET ACTIVITY LOGS
      =========================================================*/
      const getActivityLogs = () => {
        axios.get(ProjectConfig.api_url + "/stores/activityLogs", {
          params: {
            store_id: store_id,
            full_list: true
          }, 
        })
        .then((response) => {
            console.log("activityLogs res", response.data)
            setActivityLogs(response.data.list)
        })
        .catch((err) => {
            console.log(err.response.data);
        });
      }

      
    return (
        <>
            <div className="store_editor_section">

                <h2 className="section_title">Activity Logs
                    <Button 
                        variant="outlined" 
                        color="primary" 
                        onClick={() => setOpenEditor(true)}
                        className="button_2"
                    >
                        Add Log
                    </Button>
                </h2>

                <div id="activity_logs">
                    <Table>
                    <TableBody>
                        {activityLogs.map((log: any, index: number) => (
                        <TableRow key={index}>
                            <TableCell>{log.date}</TableCell>
                            <TableCell>{log.log}</TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                    </Table>
                </div>
            </div>

            <LogsEditor
                store_id={store_id}
                getActivityLogs={getActivityLogs}
                open={openEditor}
                setOpen={setOpenEditor}
            />
        </>

    )
}